import { render, staticRenderFns } from "./advert-header.vue?vue&type=template&id=5b9e0930"
import script from "./advert-header.vue?vue&type=script&lang=ts"
export * from "./advert-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports